import { RelevanceOptions } from '@/constants/filterOptions';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/new/components/shadcn/select';
import { cn } from '@/new/lib/utils';
import { Relevance } from '@/types';

export function RelevanceSelector({
  relevanceText,
  updateRelevance,
}: {
  relevanceText: Relevance;
  updateRelevance: (relevance: Relevance) => void;
}) {
  return (
    <Select value={relevanceText} onValueChange={updateRelevance}>
      <SelectTrigger
        className={cn(
          '0 flex h-6 w-fit gap-2 px-2 text-xs',
          {
            [Relevance.YES]: 'text-green-600',
            [Relevance.NO]: 'text-red-500',
            [Relevance.MAYBE]: 'text-orange-400',
          }[relevanceText] ?? '',
        )}
      >
        <SelectValue placeholder="Select Relevance" />
      </SelectTrigger>
      <SelectContent>
        {Object.values(RelevanceOptions).map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
